import { useEffect } from "react";
import { DataFile } from "interfaces";

import { SingleSelect } from "ui-components/Select";

import { useFetchDataFile } from "modules/data-files/api";
import { useGetTypesForFile } from "modules/data-files/api";

interface Props {
  fileId: string;
  onChange: (column: string | null) => unknown;
  currentSelection?: string | undefined | null;

  allowedTypes?: DataFile.ColType[];
  exclusions?: string[];

  help?: React.ReactNode;
  name?: string;
  label?: React.ReactNode;
  placeholder?: string;
}

const SingleColumnSelect = ({
  fileId,
  onChange,
  currentSelection,
  allowedTypes = [],
  exclusions = [],
  name,
  help,
  label,
  placeholder,
}: Props) => {
  const { data } = useFetchDataFile(fileId, true);
  const columnTypes = useGetTypesForFile(fileId || "");

  useEffect(() => {
    if (
      (allowedTypes || []).length >= 1 &&
      currentSelection &&
      Object.keys(columnTypes || {}).length >= 1
    ) {
      if (!allowedTypes.includes(columnTypes[currentSelection])) {
        onChange(null);
      }
    }
  }, [allowedTypes, currentSelection, columnTypes, onChange]);

  if (!data) {
    return null;
  }

  const columns = data.columns || [];
  const options = columns
    .filter((c) => {
      if (exclusions.includes(c)) {
        return false;
      }
      if (allowedTypes?.length >= 1) {
        return allowedTypes.includes(columnTypes[c]);
      }
      return true;
    })
    .sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));

  return (
    <SingleSelect
      name={name}
      allowedValues={options}
      selected={currentSelection === undefined ? null : currentSelection}
      onChange={onChange}
      help={help}
      label={label}
      placeholder={placeholder}
    />
  );
};

export default SingleColumnSelect;
